import { render, staticRenderFns } from "./retailerLocationTab.vue?vue&type=template&id=6271b882&scoped=true"
import script from "./retailerLocationTab.vue?vue&type=script&lang=js"
export * from "./retailerLocationTab.vue?vue&type=script&lang=js"
import style0 from "./retailerLocationTab.vue?vue&type=style&index=0&id=6271b882&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6271b882",
  null
  
)

export default component.exports